// extracted by mini-css-extract-plugin
export default {"disabled":"Buttons_disabled__VWGSI","rotating":"Buttons_rotating__q8q2q"};